import { available } from '@aigc/toolkit';
import type { ReactNode } from 'react';

export const Available = (props: {
  when: () => boolean;
  alter?: ReactNode;
  children: ReactNode;
}) => {
  return available(props.children, props.when, props.alter);
};
